module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-35Light.57c2bc8db25f0d448b5a36c549e2f64c.woff2";